import { render } from "./ValidOtp.vue?vue&type=template&id=5fb90bae&scoped=true"
import script from "./ValidOtp.vue?vue&type=script&lang=js"
export * from "./ValidOtp.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5fb90bae"

export default script